import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { createSentryPiniaPlugin } from "@sentry/vue";

export const pinia = createPinia();

pinia.use(piniaPluginPersistedstate).use(createSentryPiniaPlugin());
